import { defineMessages } from 'react-intl';

export default defineMessages({ 
    primaryNamedInsured:{
        id: "quoteandbind.policy-details.Primary Named Insured",
        defaultMessage: "Primary Named Insured"
    },
    policyAddress:{
        id: "quoteandbind.policy-details.Policy Address",
        defaultMessage: "Policy Address"
    },
    changePrimaryNamedInsured: {
        id: "quoteandbind.policy-details.ChangePriNamedInsured",
        defaultMessage: "Change Primary Named Insured"
    },
    changePolicyAddress: {
        id: "quoteandbind.policy-details.Change Policy Address",
        defaultMessage: "Change Policy Address"
    },
    minimumDateError:{
        id: "quoteandbind.policy-details.Coverage Start date cannot be prior to",
        defaultMessage:"Coverage Start date cannot be prior to"
    },
    rvExpiryDate:{
        id: "quoteandbind.policy-details.Expiration Date",
        defaultMessage:"Expiration Date"
    },
    rvTermType:{
        id: "quoteandbind.policy-details.Term Type",
        defaultMessage:"Term Type"
    },
    rvPriorPolInf:{
        id: "quoteandbindpolicy-details.Prior Policy",
        defaultMessage:"Prior Policy"
    },
    rvPriorCarName:{
        id: "quoteandbind.policy-details.Prior Carrier Name",
        defaultMessage:"Prior Carrier Name"
    },
    rvPriorPolNum:{
        id: "quoteandbind.policy-details.Prior Policy #",
        defaultMessage:"Prior Policy #"
    },
    rvPriorPolExp:{
        id: "quoteandbind.policy-details.Prior Policy Expiration Date",
        defaultMessage:"Prior Policy Expiration Date"
    },
    rvPriorPolYears:{
        id: "quoteandbind.policy-details.Number of Years Prior Insurance",
        defaultMessage:"Number of Years Prior Insurance"
    },
    rvPriorPolCanc:{
        id: "quoteandbind.policy-details.Have you been cancelled by an insurance company in the last 3 years",
        defaultMessage:"Have you been cancelled by an insurance company in the last 3 years"
    },
    searchExistingContact: {
        id: 'quoteandbind.policy-details.Search Existing',
        defaultMessage: '-- Search Existing --'
    },
    rvReasonForCancel:{
        id: "quoteandbind.policy-details.Reason for Cancellation or refusal",
        defaultMessage:"Reason for Cancellation or refusal"
    },
    rvExistingPolicyNumber:{
        id: "quoteandbind.policy-details.Existing Policy Number",
        defaultMessage:"Existing Policy Number"
    },
    ownership:{
        id: "quoteandbind.policy-details.Ownership",
        defaultMessage: "Ownership"
    },
    memberOfAssociation:{
        id: "quoteandbind.policy-details.Member of an Association",
        defaultMessage: "Member of an Association/Club"
    },
    businessName:{
        id: "quoteandbind.policy-details.Business Name",
        defaultMessage: "Business Name"
    },
    priorInsCan: {
        id: "quoteandbind.policy-details.Has Insurance ever been cancelled or refused new?",
        defaultMessage: "Has any insurer ever cancelled, declined or refused to renew or issue insurance of the type applied for?"
    },
    preferredLanguage : {
        id: "quoteandbind.policy-details.Preferred Language Field changed",
        defaultMessage: "Preferred Language Field changed"
    }
});
